import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Title } from "@angular/platform-browser";

import { MainConfig, FormToolsService } from "@atenea-cms";
import { HomeSliderService, HomeSliderFormService } from "../shared";

@Component({
  selector: "home-slider-form",
  templateUrl: "./home-slider-form.component.html",
  styleUrls: ["./home-slider-form.component.scss"],
})
export class HomeSliderFormComponent implements OnInit {
  loading: boolean = false;
  form: FormGroup;

  constructor(
    private titleService: Title,
    public ft: FormToolsService,
    public mainConfig: MainConfig,
    public dataService: HomeSliderService,
    public formService: HomeSliderFormService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Home Slider - " + this.mainConfig.cmsName);
    this.loading = true;

    this.dataService.getOne().subscribe((item) => {
      this.form = this.formService.getForm(item);
      this.loading = false;
    });
  }

  getSlideTitle(item, i) {
    let title = item.get("title").value.trim();
    if (!title) {
      title = `Slide ${i}`;
    }
    return title;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/home-slider-form/home-slider-form.component.ts